import React from 'react';

import escapeRegExp from 'util/escapeRegExp';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  system: any;
}

export default function Sidebar(props: Props): JSX.Element {
  const {system} = props;
  let taggedOps = system.specSelectors.taggedOperations();
  const filter = system.layoutSelectors.currentFilter();
  if (filter && filter !== true) {
    taggedOps = system.fn.opsFilter(taggedOps, filter);
  }
  function hideLastTag(): void {
    const elementKey = elementKeyFromHash(window.location.hash);
    system.layoutActions.show(elementKey, false);
  }

  function elementKeyFromHash(rawHash: string): Array<string> {
    const decodedHash = decodeURIComponent(rawHash);
    let hash = decodedHash.slice(1); // # is first character

    if (hash[0] === '/') {
      hash = hash.slice(1);
    }
    const hashArray = hash.split('/').map((val) => val || '');
    const elementKey = system.layoutSelectors.isShownKeyFromUrlHashArray(hashArray);
    return elementKey;
  }

  function navToItem(hashStr: string): void {
    hideLastTag();
    const elementKey = elementKeyFromHash(hashStr);
    system.layoutActions.show(elementKey, true);

    // `swagger-ui-react` escapes spaces with underscores for elementIds so we mimic to set up scrollIntoView.
    const escapedElementKey = elementKey.map((item: string) => escapeRegExp(item).split(' ').join('_'));
    const element = document.getElementById(escapedElementKey.join('-'))!;
    setTimeout(() => {
      element.scrollIntoView({behavior: 'smooth'});
    }, 0.2);
  }

  function sidebarItem(hash: string, classNames: string, humanReadableSummary: string): JSX.Element {
    return (
      <div
        key={hash}
        className={classNames}
        onClick={() => {
          navToItem(hash);
        }}
      >
        <a>{humanReadableSummary}</a>
      </div>
    );
  }

  function tagLineFromTag(tag: string, windowHash: string): JSX.Element {
    const tagHash = `#/${tag}`;
    const classNames = ['sidebar-tag-item'];
    const justTagWindowHash = windowHash.split('/').slice(0, 2).join('/');
    if (justTagWindowHash === tagHash) {
      classNames.push('sidebar-item-selected');
    }
    const humanReadableSummary = tag;
    return sidebarItem(tagHash, classNames.join(' '), humanReadableSummary);
  }

  return (
    <div>
      <h1>Resources</h1>
      {taggedOps
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .map((_tagObj: any, tag: string) => (
          <div key={tag}>{tagLineFromTag(tag, decodeURIComponent(window.location.hash))}</div>
        ))
        // `valueSeq()` yields values only; immutable v4's `toArray()` on a keyed map returns
        // `[key, value]` entry pairs, which would render the bare tag string next to each item.
        .valueSeq()
        .toArray()}
    </div>
  );
}
